import { createAsyncThunk } from '@reduxjs/toolkit';
import { setLoading, setShowKeywordTrackingRelease } from 'store/slices/dataLoadingSlice';
import { notificationSuccess, notificationFail } from 'store/slices/notificationSlice';
import { setUserData, setVerifyEmail, setUserDetails, setVerifyEmailMessage } from 'store/slices/authSlice';
import Messages from '../../utils/messages';
import apiClient from '../../utils/apiClient';

export const loginUser = createAsyncThunk('loginUser', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const { email, password, navigate } = _request;
    const response = await apiClient().post(`/auth/login`, { email, password });
    dispatch(setLoading(false));
    if (response?.data && response?.data.accessToken) {
      if (response?.data && response?.data?.data?.user_type === 1) {
        navigate('/sellers');
      } else {
        navigate('/dashboard');
      }

      localStorage.setItem('user_data', JSON.stringify(response?.data));
      dispatch(setUserData(response?.data));
      dispatch(notificationSuccess(Messages.SUCCESS.LOGIN));
      dispatch(setShowKeywordTrackingRelease(true));
    } else {
      dispatch(notificationFail('Failed to login using this credentials' || Messages.ERROR.LOGIN));
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.LOGIN));
  }
});

export const loginWithGoogle = createAsyncThunk('loginWithGoogle', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const { google_access_token, navigate } = _request;
    const response = await apiClient().post(`auth/google-login`, { google_access_token: google_access_token });

    dispatch(setLoading(false));
    if (response?.data && response?.data.accessToken) {
      localStorage.setItem('user_data', JSON.stringify(response?.data));
      dispatch(setUserData(response?.data));
      dispatch(notificationSuccess(Messages.SUCCESS.LOGIN));
      dispatch(notificationSuccess(Messages.SUCCESS.KEYWORDTRACKINGAVAIALABLE));
      navigate('/dashboard');
    } else {
      dispatch(notificationFail('Failed to login using this credentials' || Messages.ERROR.LOGIN));
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(Messages.ERROR.LOGIN));
  }
});

export const registerUser = createAsyncThunk('registerUser', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const {
      email,
      phone,
      company,
      // password,
      first_name,
      last_name,
      callbackFunc,
      navigate
    } = _request;

    const response = await apiClient().post(`auth/create`, {
      first_name: first_name,
      last_name: last_name,
      email: email,
      phone: phone,
      company_name: company,
      // password: password,
      user_type: 2,
      client_id: '',
      client_secret: ''
    });

    dispatch(setLoading(false));
    if (response?.data) {
      // dispatch(notificationSuccess(response.data.message));
      callbackFunc();
      navigate('/login');
      dispatch(setVerifyEmailMessage(response.data.message));
    } else {
      dispatch(notificationFail(response?.data?.message || Messages.ERROR.REGISTER));
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.REGISTER));
  }
});

export const forgetPassword = createAsyncThunk('forgetPassword', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const { email, navigate } = _request;
    const response = await apiClient().post(`auth/forgot-password`, { email });
    dispatch(setLoading(false));
    if (response?.data) {
      dispatch(notificationSuccess(Messages.SUCCESS.RESETSUCCESS));
      navigate('/login');
    } else {
      dispatch(notificationFail(Messages.ERROR.RESETFAIL));
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.DEFAULT));
  }
});

export const accountPasswordUpdate = createAsyncThunk('accountPasswordUpdate', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const { navigate } = _request;
    const response = await apiClient().post(`auth/reset-password`, _request?.cpassword);
    dispatch(setLoading(false));
    if (response?.data) {
      dispatch(notificationSuccess(response?.data?.message));
      navigate('/login');
    } else {
      dispatch(notificationFail(Messages.ERROR.DEFAULT));
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.DEFAULT));
  }
});

export const verifyAccountPassword = createAsyncThunk('verifyAccountPassword', async (_request, { dispatch }) => {
  const { verify_code } = _request.cpassword;
  try {
    dispatch(setLoading(true));
    const { navigate } = _request;
    const response = await apiClient().put(`auth/set-password/${verify_code?.id}/${verify_code?.avc}`, _request?.cpassword);
    dispatch(setLoading(false));
    if (response?.data) {
      dispatch(notificationSuccess(response?.data?.message));
      navigate('/login');
    } else {
      dispatch(notificationFail(Messages.ERROR.DEFAULT));
    }
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.DEFAULT));
  }
});

export const verifyEmail = createAsyncThunk('verifyEmail', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await apiClient().post(`auth/verify-email`, _request);

    dispatch(setLoading(false));
    dispatch(setVerifyEmail(''));
  } catch (error) {
    dispatch(setVerifyEmail(error?.response?.data?.message));
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.LOGIN));
  }
});

export const getUserDetails = createAsyncThunk('getUserDetails', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await apiClient().get(`users/user/${_request.id}`);
    dispatch(setUserDetails(response?.data));
    dispatch(setLoading(false));
    const currentLocalStorageData = JSON.parse(localStorage.getItem('user_data'));
    const updatedData = {
      ...currentLocalStorageData,
      data: response?.data?.data
    };
    localStorage.setItem('user_data', JSON.stringify(updatedData));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(Messages.ERROR.DEFAULT));
  }
});

export const logout = createAsyncThunk('logout', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await apiClient().get(`auth/logout`);
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.DEFAULT));
  }
});
export const resendActivationLink = createAsyncThunk('resendActivationLink', async (_request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await apiClient().post(`auth/send-activation-mail`, _request?.data);
    dispatch(setLoading(false));
    dispatch(notificationSuccess('Activation link sent successfully'));
    _request?.close();
  } catch (error) {
    console.log('error ', error);
    dispatch(setLoading(false));
    dispatch(notificationFail(error?.response?.data?.message || Messages.ERROR.DEFAULT));
  }
});
